import { render, staticRenderFns } from "./GoalReforecastView.vue?vue&type=template&id=a35814c6&"
import script from "./GoalReforecastView.vue?vue&type=script&lang=ts&"
export * from "./GoalReforecastView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports